import { render, staticRenderFns } from "./DownloadJsonData.vue?vue&type=template&id=9e2cd7f0"
import script from "./DownloadJsonData.vue?vue&type=script&lang=js"
export * from "./DownloadJsonData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports